import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import WP from 'WP';
import Container from 'partials/Container';
import HeadMeta from 'partials/HeadMeta';
import Footer from 'partials/Footer';
import { H1 } from 'partials/typography';

import { setCurrentView } from 'store';

class NotFound extends Component {

    componentWillMount() {
        this.props.setCurrentView({
            translation_paths: {
                no: '/404',
                en: '/en/404'
            }
        });
    }

    render() {
        return (
            <div>
                <Wrapper>

                    <HeadMeta page={{
                        yoast: {
                            title: '404 - page not found'
                        }
                    }} />

                    <Container>
                        <H1>{WP.options.title_404 || '404 - page not found'}</H1>
                        <p>{WP.options.description_404}</p>
                    </Container>
                </Wrapper>
                <Footer/>
            </div>
        );
    }
}

const actions = {
    setCurrentView,
}

export default connect(null, actions)(NotFound);

const Wrapper = styled.div`
    text-align:center;
    height: 100%;
    min-height: 70vh;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 160px;
    @media (max-width: 768px) {
        padding-top: 80px;
    }

    h1 {
        margin-bottom: 40px;
    }

    p {
        font-size:18px;
    }
`


// WEBPACK FOOTER //
// ./src/views/NotFound.js